<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="platformcode" label="平台编码" prop="platformcode">
                    <platformSelecter :platformcode="record.platformcode" v-show="is_new"  @platformChange="handlePlatformChange"></platformSelecter>
                    <span v-show="!is_new"> {{ platformName }} </span>
                </a-form-model-item>

                <a-form-model-item ref="configcode" label="配置编码" prop="configcode">
                    <configcodeSelecter v-show="is_new" ref="configcodeSelecterID" v-model="record.configcode"></configcodeSelecter>
                    <span v-show="!is_new"> {{ record.configcode }} </span>
                </a-form-model-item>

                <a-form-model-item ref="rangecode" label="层级编码" prop="rangecode">
                    <a-input v-show="is_new" placeholder="多个层级使用&符号分割" v-model="record.rangecode" />
                    <span v-show="!is_new">{{record.rangecode}}</span>
                </a-form-model-item>
                <template v-if="!is_convert">
                    <a-form-model-item ref="details" label="配置数据"  prop="details">
                        <a-button type="dashed" style="width: 60%" @click="addDetail" v-show="is_vue_task">
                            <a-icon type="plus" /> 添加配置值
                        </a-button>
                        <div id="idmyFormItems">
                            <a-card :title="'配置-' + (index + 1)" class="detailCard"  v-for="(item,index) in record.details" :key="index">
                                <a-icon slot="extra" class="closeBtn" type="close" @click="handleDelete(index)" v-show="is_vue_task" />
                                <div class="detailItem">
                                    <div class="detailName">configid：</div>
                                    <a-input class="detailValue" v-model="item.configid" />
                                </div>

                                <div class="detailItem">
                                    <JsonXmlEditor :title="'配置值：'" v-model="item.configvalue"></JsonXmlEditor>
                                </div>

                                <div class="detailItem">
                                    <JsonXmlEditor :language="'json'" :title="'额外参数：'" v-model="item.extraparam"></JsonXmlEditor>
                                </div>
                                
                            </a-card>
                        </div>
                    </a-form-model-item>
                </template>

                <template v-else>
                    <!-- <a-form-model-item ref="savemode" label="保存方式" prop="savemode">
                        <a-radio-group v-if="is_vue_task" v-model="convertRecord.savemode">
                            <a-radio v-for="(value,name) in savemodeList" :value="name" :key="name">
                                {{value}}
                            </a-radio>
                        </a-radio-group>
                        <span v-else>{{savemodeList[convertRecord.savemode]}}</span>
                    </a-form-model-item> -->

                    <a-form-model-item ref="coverflag" label="覆盖模式" prop="coverflag">
                        <a-radio-group v-if="is_vue_task" v-model="convertRecord.coverflag" @change="handleConverFlagChange">
                            <a-radio v-for="(value,name) in coverflagList" :value="name" :key="name">
                                {{value}}
                            </a-radio>
                        </a-radio-group>
                        <span v-else>{{coverflagList[convertRecord.coverflag]}}</span>
                    </a-form-model-item>

                    <a-form-model-item v-if="convertRecord.coverflag == '2'" ref="coverliststr" label="子配置层级编码" prop="coverliststr">
                        <a-input v-if="is_vue_task" placeholder="覆盖的子配置层级编码,逗号分隔" @change="handleConverListChange" v-model="convertRecord.coverliststr" />
                        <span v-else>{{convertRecord.coverlist.join(',')}}</span>
                    </a-form-model-item>

                    <a-form-model-item ref="covermode" label="覆盖方式" prop="covermode">
                        <a-radio-group v-if="is_vue_task" v-model="convertRecord.covermode">
                            <a-radio v-for="(value,name) in covermodeList" :value="name" :key="name">
                                {{value}}
                            </a-radio>
                        </a-radio-group>
                        <span v-else>{{covermodeList[convertRecord.covermode]}}</span>
                    </a-form-model-item>
                    
                    <a-form-model-item ref="notifyflag" label="是否通知" prop="notifyflag">
                        <a-radio-group v-if="is_vue_task" v-model="convertRecord.notifyflag">
                            <a-radio value="Y" name="type">
                            是
                            </a-radio>
                            <a-radio value="N" name="type">
                            否
                            </a-radio>
                        </a-radio-group>
                        <span v-else>{{convertRecord.notifyflag == Y ? '是' : '否'}}</span>
                    </a-form-model-item>

                    
                </template>

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import configcodeSelecter from '../com/configcodeSelecter'

import platformSelecter from '../com/platformSelecter'

import JsonXmlEditor from '../../../components/JsonXmlEditor'

const m_title = {
    'addconfigdetail':'新增配置明细',
    'detailconfigdetail':'查看配置明细',
    'editconfigdetail':'编辑配置明细',
    'convertconfigdetail':'覆盖配置明细',
};

export default {
   
    data() {
        return {
            // savemodeList:{
            //     '0':'全量保存',
            //     '1':'增量保存',
            //     '2':'只新增',
            //     '3':'删除',
            // },
            coverflagList:{
                '1':'覆盖所有子配置',
                '2':'指定覆盖子配置',
            },
            covermodeList:{
                '0':'全量覆盖',
                '1':'增量覆盖',
                '2':'只新增',
            },
            c_title:'',
            is_vue_task : true,
            is_new:false,
            is_convert:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 16 },
            rules: {
                platformcode: [
                    { required: true, message: ' 请选择平台 ', trigger: 'blur' },
                ],
                rangecode:[
                    { required: true, message: ' 请填写层级编码', trigger: 'blur' },
                ],
                configcode:[
                    { required: true, message: ' 请填写配置编码', trigger: 'blur' },
                ],
                details:[
                    { required: true, message: '请编辑配置数据', trigger: 'blur' },
                ],
                // coverliststr:[
                //     { required: true, message: '请输入', trigger: 'blur' },
                // ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                platformcode:'',
                platformname:'',//附加字段，子组件线上平台名称
                configcode:'',//配置编码选择
                rangecode:'',//层级编码
                details:[
                    {
                        configvalue:'',
                        extraparam:'',
                        configid:''
                    }
                    // configvalue:'',//配置值，savemode=3时（删除可不传）
                    // extraparam:'',//额外参数， savemode=3时（删除可不传）
                    // configid:'',//savemode不为0时必传，建议列表配置传该参数，用来唯一定位一条数据
                ],
                
            },
            convertRecord:{
                // savemode:'0',//保存方式
                coverflag:'2',//1-覆盖所有子配置 2-指定覆盖子配置(默认)
                covermode:'0',//覆盖子配置方式 0默认
                notifyflag:'N',//是否支持通知
                coverlist:[],//覆盖的子配置层级编码，当 coverflag 为2时必传
                coverliststr:''
            },
            platformlist:[{text:'',value:''}]
        };
    },
    computed: {
        platformName(){
            let result = this.platformlist.find(item=>{return item.value == this.record.platformcode});
            if(result){
                return result.text
            }
            else{
                return ''
            }
        }
    },
    components:{
        configcodeSelecter,
        platformSelecter,
        JsonXmlEditor,
    },
    methods: {
        handleConverFlagChange(){
            if(this.convertRecord.coverflag == '1'){
                this.convertRecord.coverlist = [];
                this.convertRecord.coverliststr = '';
            }
        },
        handleConverListChange(){
            this.convertRecord.coverlist = this.convertRecord.coverliststr.split(',');
            console.log(this.convertRecord.coverlist )
        },
        handleDelete(key){
            this.record.details= this.record.details.filter((p_item,index) => {
                return index != key
            })
        },
        addDetail(){
            this.record.details.push(
                {
                    configvalue:'',
                    extraparam:'',
                    configid:''
                }
            )
        },
        handlePlatformChange(obj){
            this.$refs.configcodeSelecterID.setPlatform(obj.platformcode);
            this.record.platformcode = obj.platformcode;
            this.record.platformname = obj.platformname;
            this.platformlist = obj.platformlist;
            const { query } = this.$route;

            if (!this.is_new) {
                this.getDetail(query)
            }
            else{
                this.resetForm();
            }
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if(that.is_convert){
                        that.confirmLoading = true;
                        that.$store
                            .dispatch({
                                type: "cloudconfig/configcover",
                                params: {
                                    platformcode:that.record.platformcode,
                                    configcode:that.record.configcode,
                                    rangecode:that.record.rangecode,
                                    operateuser:this.G.getCurrentUser().username,//操作人
                                    coverflag:that.convertRecord.coverflag,
                                    covermode:that.convertRecord.covermode,
                                    notifyflag:that.convertRecord.notifyflag,
                                    coverlist:JSON.stringify(that.convertRecord.coverlist),
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                                that.confirmLoading = false;
                            });
                    }
                    else{
                        that.confirmLoading = true;
                        that.$store
                            .dispatch({
                                type: "cloudconfig/saveconfig",
                                params: {
                                    platformcode:that.record.platformcode,
                                    configcode:that.record.configcode,
                                    rangecode:that.record.rangecode,
                                    details:JSON.stringify(that.record.details),
                                    operateuser:this.G.getCurrentUser().username,//操作人
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                                that.confirmLoading = false;
                            });
                    }
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(query){
            let that = this;
            that.$store.dispatch({
                type: "cloudconfig/queryconfig",
                params: {
                    platformcode:query.platformcode,
                    configcode:query.configcode,
                    rangecode:query.rangecode,
                    urlparams:false,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    };
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.record.platformcode = query.platformcode
        this.is_new = params.action == "addconfigdetail";
        this.is_convert = params.action == 'convertconfigdetail';
        this.is_vue_task = params.action != 'detailconfigdetail'

    },

};
</script>

<style scoped>
.closeBtn{
    font-size: 18px;
    cursor: pointer;
}

.ant-form-inline .ant-form-item{
    margin-right:40px;
}

.detailTitle{
    background-color: gray;
}

.detailItem{
    position: relative;
}

.detailName{
    width: 80px;
    display: inline-block;
}

.detailValue{
    width: 300px;
    display: inline-block;

}

.detailCard{
    margin: 10px 0;
}
</style>

<style>
    #idmyFormItems .ant-card-head-title{
        padding: 10px 0 !important;
    }

    #idmyFormItems .ant-card-extra{
        padding: 10px 0 !important;
    }

    #idmyFormItems .ant-card-head{
        min-height: 30px !important;
    }
</style>
